import { surveyInstance } from '..';

const getAllSurveys = async () => {
  const { data } = await surveyInstance('/survey');
  return data;
};

export default getAllSurveys;
